import { Center, Alert, AlertTitle } from "@chakra-ui/react";

const ErrorMessage = ({ message }) => {
    return (
        <Center minH="100vh">
            <Alert status="error">
                <AlertTitle>{message}</AlertTitle>
            </Alert>
        </Center>
    );
};

export default ErrorMessage;
